(() => {
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-axd-cookie-preferences], a[href="#shopifyReshowConsentBanner"]');
    if (!control) return;
    event.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    } else {
      location.href = control.dataset.fallback || (window.Shopify.routes.root + 'pages/politica-cookie');
    }
  });
})();
